import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDateFormat',
  standalone: true
})
export class CustomDateFormatPipe implements PipeTransform {

  transform(value: string): string | null {
    if (!value) return null;
    
    // Create an instance of DatePipe inside the transform method
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(value, 'MMM d, yyyy h:mm a');
  }

}
